module.exports = __webpack_public_path__ + "static/media/LeftArrow.f5ddaf55.svg";